/* Auren Naturals ATC — DISABLED.
   Original machte native Form-POST → /cart (Drawer-Bypass). Jetzt deaktiviert
   weil amariel-cart-drawer-patch.js den Shrine-Drawer crash-safe macht und
   openThemeCart() in amariel-magnesium-pdp-content-v3.liquid den Drawer öffnet. */
(function () {
  'use strict';
  console.log('[Auren NaturalsATC] disabled — drawer handles ATC now');
})();
